import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import Background from './Background'
import { blendConfigBg } from '../utils/colors'
import BikeImage from './BikeImage'
import PopoverOutlet from './PopoverOutlet'
import DisplayPdf from './DisplayPdf'
import ComponentList from './ComponentList'
import Header from './Header'
import { State } from 'shared'

const App: React.FC = () => {
  console.log('App')
  const rootRef = useRef<HTMLDivElement>(null)

  const isBikeOnlyLayout = useSelector((state: State) => state.isBikeOnlyLayout)
  const isPdfLayout = useSelector((state: State) => state.isPdfLayout)
  const viewportHeightDelta = useSelector(
    (state: State) => state.viewportHeightDelta
  )
  const background = useSelector((state: State) => state.bikeConfig.background)

  useEffect(() => {
    const updateCustomCssProperties = () => {
      const bg = blendConfigBg(background.color)
      if (rootRef.current) {
        rootRef.current.style.setProperty('--velorbis-customizer-config-bg', bg)
        rootRef.current.style.setProperty(
          '--velorbis-customizer-height-adjustment',
          `${viewportHeightDelta}px`
        )
      }
    }
    if (!isPdfLayout) {
      updateCustomCssProperties()
    }
  }, [isPdfLayout, background, viewportHeightDelta])

  const className = [
    'velorbis-customizer-root',
    isBikeOnlyLayout ? 'velorbis-customizer-root-bike-only' : ''
  ].join(' ')

  if (isPdfLayout) {
    return <DisplayPdf background={background} />
  }

  return (
    <div ref={rootRef} className={className}>
      <Background>
        {!isBikeOnlyLayout && <Header />}
        <BikeImage background={background} />
      </Background>
      {!isBikeOnlyLayout && <ComponentList />}
      {!isBikeOnlyLayout && <PopoverOutlet />}
    </div>
  )
}

export default App
